import React from 'react';
import { DELETE_CHARITY_MODAL } from '../../../redux/modules/modals/modals.module';
import { useDispatch } from 'react-redux';
import {
  DeleteCharity,
  resetQCDFundsValue,
} from '../../../redux/modules/qcd/qcd.module';
import './DeleteCharityModal.scss';

export const DeleteCharityModal = ({ closeModal, charityID }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <div className="header-delete-charity">
        Are you sure you want to delete this charity?
      </div>
      <div className="delete-charity-buttons">
        <button
          onClick={() => closeModal(DELETE_CHARITY_MODAL)}
          className="delete-charity-buttons-cancel"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            dispatch(DeleteCharity(charityID));
            dispatch(resetQCDFundsValue());
            closeModal(DELETE_CHARITY_MODAL);
          }}
          className="delete-charity-buttons-delete"
        >
          Yes
        </button>
      </div>
    </div>
  );
};

export default DeleteCharityModal;
